import { MainOccupationDto } from '../application/MainOccupationDto';
import { OptionsEnum } from '../../enums/OptionsEnum';

class Insured {
  public sumAssured: string;
  public dateOfBirth: string;
  public isSmoker: string;

  constructor() {
    this.sumAssured = '';
    this.dateOfBirth = '';
    this.isSmoker = '';
  }
}

export class CalculationOrvForm {
  public annuityRate: string;
  public dateOfCommencement: Date | undefined;
  public insured: Insured;
  public numberOfYears: string;
  public premiums: string;
  public secondInsured: Insured;
  public secondInsuredPresent: string;
  public typeOfCover: string;

  constructor() {
    this.annuityRate = '';
    this.insured = new Insured();
    this.numberOfYears = '';
    this.premiums = '';
    this.secondInsured = new Insured();
    this.secondInsuredPresent = '';
    this.typeOfCover = '';
  }
}

export class CalculationGgForm {
  public annuityRate = '';
  public dateOfCommencement: Date | undefined;
  public dateOfBirth: Date | undefined;
  public insured: Insured = new Insured();
  public claimDuration = '';
  public typeOfCover = '';
  public sumAssured = '';
  public occupation = '';
  public waitingPeriod = 'DAYS_90';
  public mentalIllness: OptionsEnum = OptionsEnum.No;
  public indexationUsage: OptionsEnum = OptionsEnum.No;
  public insuredOccupation: MainOccupationDto | undefined;
}
